/**
 * 登录/鉴权
 */

import BaseAuthClient from './baseAuth';

class AuthClient extends BaseAuthClient {
  constructor() {
    super({ baseURL: '/api' });
  }
}

const authClient = new AuthClient();

export default authClient;

// 登录
export const login = (option: any) => authClient.post(`/login`, option);

// 扫码登录
export const scanLogin = (option: any) => authClient.post(`/dingtalk/scanlogin`, option);

// 选择或切换用户所在的二级部门
export const changeUserDept = (option: any) => authClient.post(`/v1/dept/changeuserdept`, option);

// 登出
export const logout = (option: any) => authClient.post(`/logout`, option);

// 判断是否在登录状态，返回用户信息
export const isLogin = (option: any) => authClient.get(`/login/islogin`, option);
